import { render, staticRenderFns } from "./EditUpload.vue?vue&type=template&id=669d512b&scoped=true"
import script from "./EditUpload.vue?vue&type=script&lang=js"
export * from "./EditUpload.vue?vue&type=script&lang=js"
import style0 from "./EditUpload.vue?vue&type=style&index=0&id=669d512b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d512b",
  null
  
)

export default component.exports